module.exports = __webpack_public_path__ + "lk.svg?f4a88527a0f631e816bfa30b4dfd900e";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/lk.svg
// module id = 1112
// module chunks = 27